import { partyKeys } from '@my/directory-api/hooks';
import { tmsApi } from '@my/tms-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * Delete a customer / supplier THROUGH TMS: the server refuses (409, naming
 * the orders and invoices) while the party is on any order, and only then asks
 * Directory to delete it. Directory refuses a delete that didn't come this way
 * unless it is Stratum support — so this, not `useDeleteParty`, is the TMS
 * delete. Same cache effect as `useDeleteParty`.
 */
export function useDeletePartyViaTms() {
  const queryClient = useQueryClient();
  return useMutation<unknown, Error, { id: string; organisationId: string }>({
    mutationFn: ({ id }) => tmsApi.deleteParty(id),
    onSuccess: (_, { organisationId, id }) => {
      queryClient.invalidateQueries({ queryKey: ['directory', 'parties', 'org', organisationId] });
      queryClient.removeQueries({ queryKey: partyKeys.byId(id) });
    },
  });
}
